<template>
  <div>
    <h3>Other Applications</h3>
    <div v-if="isFetchingApplications">
      <v-skeleton-loader v-for="i in 3" :key="i" type="list-item-avatar" />
    </div>
    <div v-else>
      <v-list-item
        v-for="application in filteredApplications"
        :key="application.id"
        @click="() => handleSelect(application)"
      >
        <ApplicationListItem :application="application" />
      </v-list-item>
      <span v-if="isListEmpty"> - </span>
    </div>
    <v-divider class="my-4" />
  </div>
</template>

<script>
import { WORKERS_NAMESPACE } from "@/store/modules/workers";
import { FETCH_WORKER_APPLICATIONS } from "@/store/modules/workers/action-types";
import { createNamespacedHelpers } from "vuex";
import { filter, isEmpty } from "lodash";
import ApplicationListItem from "@/views/applications/components/ApplicationListItem";

const { mapActions, mapState } = createNamespacedHelpers(WORKERS_NAMESPACE);

export default {
  name: "OtherApplications",
  components: { ApplicationListItem },
  created() {
    this.fetchUserApplications({ filter: { user_id: this.userId } });
  },
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState(["isFetchingApplications", "applications"]),
    filteredApplications() {
      return filter(
        this.applications,
        ({ booking }) => booking.id !== this.currentBookingId
      );
    },
    isListEmpty() {
      return isEmpty(this.filteredApplications);
    },
    currentBookingId() {
      return this.$route.params.id;
    }
  },
  methods: {
    ...mapActions({
      fetchUserApplications: FETCH_WORKER_APPLICATIONS
    }),
    handleSelect(application) {
      this.$router.replace({
        path: `/jobs/${application.booking.id}/candidates`,
        query: { applicationId: application.id }
      });
    }
  }
};
</script>
